import * as fuzzysort from "fuzzysort";
export default class PreparedSearchIndex {
    constructor(items, key, default_options = {}) {
        this.default_options = default_options;
        this.index = items.map(i => ({ value: i, prepared: fuzzysort.prepare(key(i)) }));
    }
    do(term, options = {}) {
        return fuzzysort.go(term, this.index, {
            ...this.default_options,
            ...options,
            key: "prepared"
        }).map(i => ({
            ...i,
            obj: i.obj.value
        }));
    }
    search(term, options = {}) {
        return this.do(term, options).map(v => v.obj);
    }
    setDefaultOptions(options) {
        this.default_options = options;
        return this;
    }
    items() {
        return this.index.map(e => e.value);
    }
}
